import React, { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Divider,
  DatePicker,
  InputNumber,
  Row,
  Col,
  Space,
  notification,
  Modal,
  Checkbox,
} from 'antd';
import moment from 'moment';
import { DATE_FORMAT } from '~commons/constants';
import ApiServices from '~services';
import { HeaderFormCreate } from './header-form-create';
import { FeeItem } from './fee-item';
import { ShowDataAfterImport } from './show-data-after-import';

const FormCreate = ({ dataCar, dataInfo, expensesSelected, reload, dissolveDateDefault }) => {
  const formRef = React.useRef(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [vat, setVat] = useState(0);
  const [fieldsExpense, setFieldsExpense] = useState([]);
  const [dateDissolveInit, setDateDissolveInit] = useState(null);

  const [dataAfterImport, setDataAfterImport] = useState([]);
  const [checkedWarning, setCheckedWarning] = useState(false);

  useEffect(() => {
    setDateDissolveInit(dissolveDateDefault);
  }, []);
  useEffect(() => {
    formRef.current?.resetFields();
  }, [expensesSelected]);

  function financial(x) {
    return Math.round(Number.parseFloat(x));
  }

  const getVatByDateInit = async (date) => {
    setLoading(true);
    try {
      let { data } = await ApiServices.getVatByDate(date);

      let vatInit = 0;
      if (data?.data) {
        vatInit = data?.data?.vat || 0;
      }

      const expenseInit = expensesSelected?.map((item) => {
        let priceNoVat = 0;
        if (item?.fee) {
          const priceNoVatCalc = item?.fee / (1 + vatInit / 100);
          priceNoVat = Number.parseInt(financial(priceNoVatCalc));
        }

        return {
          name: item?.name,
          pay: item?.pay,
          billRequired: item?.billRequired,
          expenseId: item.id,
          price: priceNoVat ? priceNoVat : 0,
          vat: vatInit || 0,
          total: item?.fee ? item?.fee : 0,
          supplierName: item?.supplierName
            ? item?.supplierName
            : item?.supplier
            ? item?.supplier
            : '',
          billNumber: item?.billNumber || '',
          billDate: dataInfo?.assignDate ? moment(dataInfo.assignDate) : null,
          // billDate: dataInfo?.contNumberDate ? moment(dataInfo.contNumberDate) : null,
        };
      });
      setFieldsExpense(expenseInit);
      setVat(vatInit);
      setDateDissolveInit(null);
    } catch (error) {
      console.log('Get supplier bill failed:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (expensesSelected?.length) {
      getVatByDateInit(
        dateDissolveInit
          ? moment(dateDissolveInit).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD')
      );
    }
  }, [expensesSelected]);

  const getVatByDate = async (date) => {
    setLoading(true);
    try {
      let { data } = await ApiServices.getVatByDate(date);
      if (data?.data) {
        if (data?.data?.vat !== vat) {
          const expenseInit = fieldsExpense?.map((item) => {
            let priceNoVat = 0;
            if (item?.fee) {
              const priceNoVatCalc = item?.fee / (1 + data?.data?.vat / 100);
              priceNoVat = Number.parseInt(financial(priceNoVatCalc));
            }

            return {
              name: item?.name,
              pay: item?.pay,
              billRequired: item?.billRequired,
              expenseId: item.expenseId,
              price: priceNoVat ? priceNoVat : 0,
              vat: data?.data?.vat || 0,
              total: item?.fee ? item?.fee : 0,
              supplierName: item?.supplierName
                ? item?.supplierName
                : item?.supplier
                ? item?.supplier
                : '',
              billNumber: item?.billNumber || '',
              billDate: item?.billDate ? moment(item?.billDate) : null,
            };
          });
          setFieldsExpense(expenseInit);
          setVat(data?.data?.vat);
        }
      }
    } catch (error) {
      console.log('Get supplier bill failed:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleChangeDissolveDate = (date) => {
    if (!date) {
      setDateDissolveInit(dissolveDateDefault ? dissolveDateDefault : moment());
      setVat(0);
      return;
    }

    setDateDissolveInit(date);
    const dateFormat = moment(date).format('YYYY-MM-DD');
    return getVatByDate(dateFormat);
  };
  const handleCancelShowDataImported = () => {
    setDataAfterImport([]);
  };
  const handleClick = (dataImport) => {
    notification.close(key);
    setDataAfterImport(dataImport);
  };

  const key = `open${Date.now()}`;
  const btn = (dataImport) => {
    return (
      <Space>
        <Button type='link' size='small' onClick={() => handleClick(dataImport)}>
          Xem chi tiết {'>>'}
        </Button>
      </Space>
    );
  };
  const onFinish = async (values, ignoreWarning = false) => {
    if (loading) return;
    let showError = false;

    const dataExpense = fieldsExpense?.map((item) => {
      if (
        !item?.price ||
        !item.vat ||
        !item.total ||
        (item?.billRequired && !item.billNumber) ||
        (item?.billRequired && !item.billDate) ||
        (item?.billRequired && !item.supplierName)
      ) {
        showError = true;
        return;
      }
      return {
        expenseId: item?.expenseId,
        price: item?.price,
        vat: item?.vat,
        total: item?.total,
        supplierName: item?.supplierName,
        billNumber: item?.billNumber,
        billDate: item?.billDate && moment(item?.billDate).format('YYYY-MM-DD'),
      };
    });
    if (showError) {
      return window.TmsNoti?.error('Lỗi', 'Vui lòng nhập đầy đủ thông tin');
    }
    if (dataInfo?.authorizedCont) {
      const dataSend = {
        expenses: dataExpense,
        dissolveDate: values?.dissolveDate && moment(values?.dissolveDate).format('YYYY-MM-DD'),
        folder: values?.folder,
        note: values?.note,
        vendorNumber: values?.vendorNumber,
        commission: true,
        orderType: dataInfo?.orderType,
        bookingDeliveryContRequestDate:
          dataInfo?.bookingDeliveryContRequestDate &&
          moment(dataInfo?.bookingDeliveryContRequestDate).format('YYYY-MM-DD'),
        billReceivedDate:
          dataInfo?.billReceivedDate && moment(dataInfo?.billReceivedDate).format('YYYY-MM-DD'),
        driverMainName: dataCar?.name,
        ignoreWarning,
      };

      setLoading(true);
      return ApiServices.createJobForVendorTicketWithAuthorizedCont(dataInfo.contId, dataSend)
        .then((res) => {
          if (res?.data) {
            window.TmsNoti.successCustom(
              'Thao tác thành công',
              '',
              8,
              () => btn(res?.data?.data || []),
              key
            );
            setFieldsExpense([]);
            reload(dataInfo.contId);
            formRef.current?.resetFields();
          }
        })
        .catch((err) => {
          console.log('Create Job for vendor ticket cont failed: ', err);
        })
        .finally(() => setLoading(false));
    } else {
      const dataSend = {
        expenses: dataExpense,
        dissolveDate: values?.dissolveDate && moment(values?.dissolveDate).format('YYYY-MM-DD'),
        folder: values?.folder,
        note: values?.note,
        jobId: dataInfo?.jobId,
        driverMainName: dataCar?.name,
        assignDate: dataInfo?.assignDate && moment(dataInfo?.assignDate).format('YYYY-MM-DD'),
        isVendor: true,
        vendorNumber: values?.vendorNumber,
      };

      setLoading(true);
      return ApiServices.createJobForVendorTicket(dataInfo.contId, dataSend)
        .then((res) => {
          if (res?.data) {
            window.TmsNoti.successCustom(
              'Thao tác thành công',
              '',
              8,
              () => btn(res?.data?.data || []),
              key
            );
            reload(dataInfo.contId);
            formRef.current?.resetFields();
          }
        })
        .catch((err) => {
          console.log('Create Job for vendor ticket cont failed: ', err);
        })
        .finally(() => setLoading(false));
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const renderItem = (item, index) => {
    return (
      <FeeItem
        key={item.expenseId}
        index={index}
        data={item}
        vat={vat}
        fieldsExpense={fieldsExpense}
        setFieldsExpense={setFieldsExpense}
        jobId={dataInfo?.jobId}
      />
    );
  };
  const onChangeIgnoreWarning = (e) => {
    setCheckedWarning(e.target.checked);
  };

  return (
    <div>
      <HeaderFormCreate dataInfo={dataInfo} dataCar={dataCar} />
      <Divider
        style={{
          color: 'blue',
        }}
      >
        Thông tin chi phí{' '}
      </Divider>
      <Form
        name='basic'
        form={form}
        ref={formRef}
        labelCol={{
          span: 16,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={(values) => onFinish(values, checkedWarning)}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
        layout='vertical'
        fields={[
          {
            name: ['dissolveDate'],
            value: dateDissolveInit
              ? moment(dateDissolveInit)
              : dissolveDateDefault
              ? moment(dissolveDateDefault)
              : moment(),
          },
        ]}
      >
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label='Ngày giải trừ'
              name='dissolveDate'
              rules={[
                {
                  required: true,
                  message: 'Bạn phải nhập ngày giải trừ!',
                },
              ]}
            >
              <DatePicker
                allowClear={false}
                placeholder='Ngày giải trừ'
                style={{ width: '100%' }}
                format={DATE_FORMAT}
                onChange={handleChangeDissolveDate}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label='STT Folder'
              name='folder'
              rules={[
                {
                  required: true,
                  message: 'Bạn phải nhập STT Folder!',
                },
              ]}
            >
              <InputNumber
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label='Số xe'
              name='vendorNumber'
              rules={[
                {
                  required: true,
                  message: 'Bạn phải nhập Số xe!',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label='Ghi chú' name='note'>
              <Input />
            </Form.Item>
          </Col>
        </Row>

        {fieldsExpense?.length && fieldsExpense?.map(renderItem)}
        <Form.Item
          wrapperCol={{
            offset: 10,
            span: 16,
          }}
        >
          <Button
            type='primary'
            htmlType='submit'
            loading={loading}
            style={{
              padding: '0px 30px',
            }}
          >
            Lưu
          </Button>
          <Checkbox
            style={{
              marginLeft: 40,
            }}
            checked={checkedWarning}
            onChange={onChangeIgnoreWarning}
          >
            Bỏ qua cảnh báo
          </Checkbox>
        </Form.Item>
      </Form>
      <Modal
        title='Danh sách Giải Trừ'
        open={!!dataAfterImport?.length}
        onCancel={handleCancelShowDataImported}
        footer={null}
        style={{
          top: 20,
        }}
        width='100%'
      >
        <ShowDataAfterImport data={dataAfterImport} />
      </Modal>
    </div>
  );
};

export { FormCreate };
